var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 42,
    viewBox: "0 0 31 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M27.6786 42H3.32143C1.48705 42 0 40.4753 0 38.5946V3.4186C0 1.53785 1.48705 0 3.32143 0H20.197L31 10.7442V38.5946C31 40.4754 29.5129 42 27.6786 42Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45458 19.0464C8.45458 19.8556 7.82371 20.5115 7.04549 20.5115C6.26727 20.5115 5.6364 19.8556 5.6364 19.0464C5.6364 18.2372 6.26727 17.5813 7.04549 17.5813C7.82371 17.5813 8.45458 18.2372 8.45458 19.0464Z",
    fill: "#DFEBFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45458 23.9303C8.45458 24.7395 7.82371 25.3954 7.04549 25.3954C6.26727 25.3954 5.6364 24.7395 5.6364 23.9303C5.6364 23.1212 6.26727 22.4652 7.04549 22.4652C7.82371 22.4652 8.45458 23.1212 8.45458 23.9303Z",
    fill: "#DFEBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45458 28.8139C8.45458 29.6231 7.82371 30.2791 7.04549 30.2791C6.26727 30.2791 5.6364 29.6231 5.6364 28.8139C5.6364 28.0048 6.26727 27.3488 7.04549 27.3488C7.82371 27.3488 8.45458 28.0048 8.45458 28.8139Z",
    fill: "#DFEBFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 19.0464C10.3332 18.2372 10.973 17.5813 11.7622 17.5813H23.9346C24.7238 17.5813 25.3635 18.2372 25.3635 19.0464C25.3635 19.8556 24.7238 20.5115 23.9346 20.5115H11.7622C10.973 20.5115 10.3332 19.8556 10.3332 19.0464Z",
    fill: "#DFEBFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 23.9303C10.3332 23.1212 10.973 22.4652 11.7622 22.4652H23.9346C24.7238 22.4652 25.3635 23.1212 25.3635 23.9303C25.3635 24.7395 24.7238 25.3954 23.9346 25.3954H11.7622C10.973 25.3954 10.3332 24.7395 10.3332 23.9303Z",
    fill: "#DFEBFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 28.8139C10.3332 28.0048 10.973 27.3488 11.7622 27.3488H23.9346C24.7238 27.3488 25.3635 28.0048 25.3635 28.8139C25.3635 29.6231 24.7238 30.2791 23.9346 30.2791H11.7622C10.973 30.2791 10.3332 29.6231 10.3332 28.8139Z",
    fill: "#DFEBFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "dark",
    d: "M20.197 7.33878V0L31 10.7442H23.5184C21.684 10.7442 20.197 9.21953 20.197 7.33878Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForm);
export default __webpack_public_path__ + "static/media/iconForm.b8d785a53e47d0e21aaeacc7f78745b4.svg";
export { ForwardRef as ReactComponent };